export default __webpack_public_path__ + "static/media/5.25b0a157.jpg";